import { useContext } from 'react'
import { PixelManipulationEditorContext } from '../context'

export function usePixelManipulationEditorContext() {
  const { setCanvas, canvas, activeObject, setActiveObject, zoomRatio, editor } = useContext(PixelManipulationEditorContext)

  return {
    setCanvas,
    canvas,
    activeObject,
    setActiveObject,
    zoomRatio,
    editor
  }
}
